import React from "react";

/**
 * The Heading component will render an h1 tag with the "text" prop as the
 * text for the heading.
 *
 * @param { string } text -> The string that is used in the heading.
 */
export default function Heading({ text }) {
  return (
    <h1 className="gc__heading">{text}</h1>
  )
}
